import { render, staticRenderFns } from "./DesignerV3Page.vue?vue&type=template&id=06985c7d&scoped=true&"
import script from "./DesignerV3Page.vue?vue&type=script&lang=js&"
export * from "./DesignerV3Page.vue?vue&type=script&lang=js&"
import style0 from "./DesignerV3Page.vue?vue&type=style&index=0&id=06985c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06985c7d",
  null
  
)

export default component.exports